import { IntegrationScheduleItem } from '../../../core/models/integration/integration-schedule-item.model';
import { createAction, props } from '@ngrx/store';

export const loadIntegrationScheduleItems = createAction('[Integration Schedule Items Facade] Load Integration Schedule Items');
export const loadIntegrationScheduleItemsSuccess = createAction(
    '[Load Integration Schedule Items Effect] Integration Schedule Items Loaded',
    props<{ integrationScheduleItems: Array<IntegrationScheduleItem> }>()
);
